import { apiRequest } from '../../shared/api/base'

interface BlockedSendersResponse {
  blockedSenders: string[]
}

export async function getBlockedSenders(): Promise<string[]> {
  const res = await apiRequest<BlockedSendersResponse>('/settings/blocked-senders')
  return res.blockedSenders
}

export async function addBlockedSender(entry: string): Promise<string[]> {
  const res = await apiRequest<BlockedSendersResponse>('/settings/blocked-senders', {
    method: 'POST',
    body: JSON.stringify({ entry }),
  })
  return res.blockedSenders
}

export async function removeBlockedSender(entry: string): Promise<string[]> {
  const res = await apiRequest<BlockedSendersResponse>(
    `/settings/blocked-senders/${encodeURIComponent(entry)}`,
    { method: 'DELETE' },
  )
  return res.blockedSenders
}
